import React, { Component } from 'react';
import PropTypes from 'prop-types';
import loadjs from 'loadjs';
import _ from 'lodash';

import CompanyHeader from './company-header/company-header';
import CompanyJob from './company-job/company-job';
import CompanyApplyJob from './company-apply-job/company-apply-job';

class JobPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayNoTrackingGrnhseApp: false,
    };
  }

  componentDidMount() {
    this.determineJobAppForm();
  }

  determineJobAppForm() {
    const queryString = location.search; // eslint-disable-line no-restricted-globals
    if (queryString && queryString.includes('gh_src=')) {
      this.appendNode();
      loadjs(
        'https://boards.greenhouse.io/embed/job_board/js?for=nerdwallet',
        () => {}
      );
    } else {
      this.setState({
        displayNoTrackingGrnhseApp: true,
      });
    }
  }

  appendNode() {
    const grnhseNode = document.createElement('div');
    grnhseNode.id = 'grnhse_app';
    grnhseNode.style = 'margin: 0 auto; text-align: center;';
    this.divNode.appendChild(grnhseNode);
  }

  render() {
    const { displayNoTrackingGrnhseApp } = this.state;
    const { job } = this.props;
    const grnhseThis = this;

    return (
      <div
        ref={(ref) => {
          grnhseThis.divNode = ref;
        }}
        className="grnhse_app_cont"
      >
        <CompanyJob job={job} />
        <div id="applyJob">
          <CompanyHeader headerText="Apply for this role" />
          {displayNoTrackingGrnhseApp && (
            <CompanyApplyJob id={_.get(job, 'id')} />
          )}
        </div>
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
JobPage.displayName = 'Job Page';

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
JobPage.propTypes = {
  job: PropTypes.object.isRequired,
};

export default JobPage;
